import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const googleAdminConsole = defineConnector({
  identifier: "googleAdminConsole",
  name: "Google Admin Console",
  tagLine: "Google Workspace directory administration",
  keywords:
    "google workspace gsuite g suite gws admin sdk directory api users groups",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: () => "https://admin\\.googleapis\\.com/.*",
  auth: (app) => bearerAuth(app.secret.accessToken),
  steps: [
    {
      title: "Create an OAuth 2.0 access token",
      items: [
        {
          kind: "markdown",
          content:
            "Follow the official docs at [https://developers.google.com/workspace/guides/auth-overview](https://developers.google.com/workspace/guides/auth-overview) and [https://developers.google.com/workspace/admin/directory/reference/rest](https://developers.google.com/workspace/admin/directory/reference/rest) to create an OAuth 2.0 access token with the required Admin SDK scopes. For organization-wide access, Google documents service accounts with domain-wide delegation.",
        },
      ],
    },
    {
      title: "Enter your connection details",
      items: [
        {
          kind: "input",
          label: "OAuth 2.0 access token",
          required: true,
          target: {
            kind: "secrets",
            field: "accessToken",
          },
        },
        {
          kind: "test-url",
          label: "Test URL",
          placeholder: "https://admin.googleapis.com/",
          helperText:
            "Optional. Set this if you want testing to hit a specific endpoint instead of the default draft URL.",
          urlTarget: {
            kind: "configuration",
            field: "testUrl",
          },
          methodTarget: {
            kind: "configuration",
            field: "testMethod",
          },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ testUrl, testMethod }) => ({
      url:
        testUrl ??
        (() => "https://admin.googleapis.com/admin/directory/v1/users")(),
      method: testMethod === "POST" ? "POST" : "GET",
    }),
  },
});
